function add(a: number, b: number) {
  console.log('typescript is running');
  return a + b;
}

export { add };
